
import { Tooltip} from '@mantine/core';
import intl from "react-intl-universal";
import { Accessible, AccessibleOff } from "tabler-icons-react";



const IdentAustriaConfirmButton = (props:any) => {
  
 // console.log(props)
  return (
    <>
    {!props.idaustriaident && props.idaustriaident !== undefined && !props.loadidadata &&
        <Tooltip label={intl.get('IDENTBUTTONS_TT_IDAUSTRIA')} >
            <span>
              <Accessible size={38} strokeWidth={1} color="green" onClick={() => props.getidaustriadata()} />
            </span>
          </Tooltip> 
    }

          
    {props.idaustriaident && props.idaustriaident !== undefined &&
          <Tooltip label={intl.get('IDA_DATA_CONFIRM_REMOVE')} >
            <span>
              <AccessibleOff size={38} strokeWidth={1} color="red" onClick={() => props.handleOpenRemoveConfirm()} />
            </span>
          </Tooltip>
          }

      
   
    </>
  );
}

export default IdentAustriaConfirmButton;